import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { getLogo } from '../helpers/Generichelper';
import { getChannelSettingByKey } from '../../routes/generic/Helpers/GenericIndexHelper';
import { useStylesFooterLogo } from '../styles/FooterStyles';

// width comes from the parent rather than a second useWindowDimensions call: FooterLayout is this
// component's only caller and already subscribes, so its own hook would add a duplicate resize
// listener and a second setState per pixel for the same number.
function FooterLogo({ width }) {
	const theme = useTheme();
	const secondaryLogoTextColor = getChannelSettingByKey('Footer-Logo-Text-Color');
	const classes = useStylesFooterLogo(theme, secondaryLogoTextColor, width);
	const agentDetails = useSelector(({ fuse }) => fuse?.form?.referenceTokenDetails?.agentDetails);
	const footerLogo =
		agentDetails?.agentLogoType === 2 && agentDetails?.agentLogoBlobUrl
			? agentDetails?.agentLogoBlobUrl
			: getLogo()?.secondaryLogo;
	const secondaryLogoText = getChannelSettingByKey('SECONDARY-LOGO-TEXT');

	return (
		<div style={classes.container}>
			<Link to="/" style={classes.linkContainer}>
				{footerLogo && <img style={classes.logo} src={footerLogo} alt="" />}
			</Link>
			{secondaryLogoText && <span style={classes.logoText}>{secondaryLogoText}</span>}
		</div>
	);
}

FooterLogo.propTypes = {
	width: PropTypes.number
};

export default FooterLogo;
